import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MODE_ICONS = { 'Bank Transfer':'🏦', 'Cheque':'📝', 'RTGS':'⚡', 'UPI':'📱', 'Cash':'💵', 'Credit Card':'💳' };
const STATUS_COLORS = { Received:{ bg:'#dcfce7', color:'#16a34a' }, Pending:{ bg:'#fef9c3', color:'#ca8a04' }, Overdue:{ bg:'#fee2e2', color:'#dc2626' } };

export default function PaymentsReceived() {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [filterStatus, setFilterStatus] = useState('All');

    useEffect(() => {
        axios.get('/api/payments')
            .then(r => setPayments(r.data))
            .catch(() => setPayments([]))
            .finally(() => setLoading(false));
    }, []);

    const filtered = payments.filter(p =>
        (filterStatus === 'All' || p.status === filterStatus) &&
        (p.client.toLowerCase().includes(search.toLowerCase()) ||
         p.invoiceNo.toLowerCase().includes(search.toLowerCase()) ||
         (p.ref || '').toLowerCase().includes(search.toLowerCase()))
    );

    const totalReceived = payments.filter(p => p.status === 'Received').reduce((a, p) => a + p.amount, 0);
    const totalPending  = payments.filter(p => p.status === 'Pending').reduce((a, p) => a + p.amount, 0);
    const totalOverdue  = payments.filter(p => p.status === 'Overdue').reduce((a, p) => a + p.amount, 0);

    const recordPayment = async () => {
        const client = prompt('Client Name:');
        const inv = prompt('Invoice No:');
        const amt = prompt('Amount (₹):');
        const mode = prompt('Payment Mode (Bank Transfer / UPI / Cheque / RTGS / Cash):') || 'Bank Transfer';
        if (client && inv && amt) {
            try {
                const res = await axios.post('/api/payments', {
                    client, invoiceNo: inv,
                    amount: parseFloat(amt) || 0, mode,
                    date: new Date().toLocaleDateString('en-GB').replace(/\//g, '/'),
                    status: 'Received'
                });
                setPayments(prev => [...prev, res.data.payment]);
            } catch { alert('Failed to record payment'); }
        }
    };

    const deletePayment = async (id) => {
        if (!window.confirm('Delete this payment record?')) return;
        try {
            await axios.delete(`/api/payments/${id}`);
            setPayments(prev => prev.filter(p => p.id !== id));
        } catch { alert('Delete failed'); }
    };

    return (
        <>
            <style>{`
                .pmt-row { transition:background 0.15s; cursor:pointer; }
                .pmt-row:hover { background:#f8fafc !important; }
                .pmt-btn { display:inline-flex; align-items:center; gap:6px; padding:8px 16px; border-radius:9px; border:none; font-family:'Inter',sans-serif; font-weight:600; font-size:13px; cursor:pointer; transition:all 0.2s; }
                .pmt-btn:hover { transform:translateY(-1px); }
                .pmt-badge { padding:4px 12px; border-radius:20px; font-size:11px; font-weight:700; display:inline-block; }
                .pmt-search { padding:10px 14px 10px 36px; border-radius:9px; border:1.5px solid #e2e8f0; font-size:13px; font-family:'Inter',sans-serif; outline:none; transition:all 0.2s; width:220px; background:#f8fafc; }
                .pmt-search:focus { border-color:#10b981; background:#fff; box-shadow:0 0 0 3px rgba(16,185,129,0.1); }
                .filter-pill { padding:6px 14px; border-radius:20px; border:1.5px solid #e2e8f0; font-size:12px; font-weight:600; cursor:pointer; transition:all 0.2s; background:#fff; color:#64748b; font-family:'Inter',sans-serif; }
                .filter-pill.active { background:#10b981; border-color:#10b981; color:#fff; }
                .filter-pill:hover:not(.active) { border-color:#94a3b8; }
                .pmt-stat { background:#fff; border-radius:14px; padding:20px 24px; border:1px solid #f1f5f9; box-shadow:0 2px 12px -4px rgba(0,0,0,0.06); transition:all 0.2s; }
                .pmt-stat:hover { transform:translateY(-2px); box-shadow:0 8px 24px -6px rgba(0,0,0,0.1); }
            `}</style>

            <div style={{ display:'flex', flexDirection:'column', gap:'20px', fontFamily:'Inter,sans-serif' }}>
                {/* Stats Row */}
                <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'16px' }}>
                    {[
                        { label:'Total Received', value:`₹${(totalReceived/1000).toFixed(1)}K`, icon:'✅', color:'#16a34a', bg:'#dcfce7', sub:`${payments.filter(p=>p.status==='Received').length} payments` },
                        { label:'Pending',         value:`₹${(totalPending/1000).toFixed(1)}K`,  icon:'⏳', color:'#ca8a04', bg:'#fef9c3', sub:`${payments.filter(p=>p.status==='Pending').length} payments` },
                        { label:'Overdue',          value:`₹${(totalOverdue/1000).toFixed(1)}K`,  icon:'🚨', color:'#dc2626', bg:'#fee2e2', sub:`${payments.filter(p=>p.status==='Overdue').length} payments` },
                        { label:'This Month',       value:`₹${((totalReceived)/1000).toFixed(1)}K`, icon:'📅', color:'#8b5cf6', bg:'#f5f3ff', sub:'May 2026' },
                    ].map(s => (
                        <div key={s.label} className="pmt-stat">
                            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                                <div>
                                    <div style={{ fontSize:'12px', fontWeight:'600', color:'#64748b', marginBottom:'6px' }}>{s.label}</div>
                                    <div style={{ fontSize:'26px', fontWeight:'800', color:s.color }}>{s.value}</div>
                                    <div style={{ fontSize:'11px', color:'#94a3b8', marginTop:'4px' }}>{s.sub}</div>
                                </div>
                                <div style={{ width:'44px', height:'44px', borderRadius:'12px', background:s.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'22px' }}>{s.icon}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Collection Bar */}
                <div style={{ background:'#fff', borderRadius:'14px', padding:'18px 24px', border:'1px solid #f1f5f9', boxShadow:'0 2px 12px -4px rgba(0,0,0,0.06)' }}>
                    <div style={{ fontSize:'13px', fontWeight:'700', color:'#64748b', marginBottom:'10px' }}>Collection Overview — Live from Server</div>
                    <div style={{ display:'flex', height:'10px', borderRadius:'10px', overflow:'hidden', gap:'2px' }}>
                        <div style={{ flex: totalReceived || 1, background:'#10b981', borderRadius:'10px 0 0 10px' }}></div>
                        <div style={{ flex: totalPending || 0.01, background:'#f59e0b' }}></div>
                        <div style={{ flex: totalOverdue || 0.01, background:'#ef4444', borderRadius:'0 10px 10px 0' }}></div>
                    </div>
                    <div style={{ display:'flex', gap:'20px', marginTop:'10px', fontSize:'12px' }}>
                        {[['#10b981','Received',totalReceived],['#f59e0b','Pending',totalPending],['#ef4444','Overdue',totalOverdue]].map(([c,l,v]) => (
                            <span key={l} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                                <span style={{ width:'10px', height:'10px', borderRadius:'50%', background:c, display:'inline-block' }}></span>
                                <span style={{ color:'#475569' }}>{l} <strong>₹{v.toLocaleString('en-IN')}</strong></span>
                            </span>
                        ))}
                    </div>
                </div>

                {/* Main Table */}
                <div style={{ background:'#fff', borderRadius:'16px', boxShadow:'0 4px 24px -8px rgba(0,0,0,0.08)', border:'1px solid #f1f5f9', overflow:'hidden' }}>
                    <div style={{ padding:'20px 24px', borderBottom:'1px solid #f1f5f9', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'12px' }}>
                        <div>
                            <h2 style={{ margin:0, fontSize:'18px', fontWeight:'800', color:'#0f172a' }}>💳 Payments Received</h2>
                            <p style={{ margin:'3px 0 0', fontSize:'13px', color:'#94a3b8' }}>All incoming payments against invoices</p>
                        </div>
                        <div style={{ display:'flex', gap:'10px', alignItems:'center', flexWrap:'wrap' }}>
                            <div style={{ position:'relative' }}>
                                <span style={{ position:'absolute', left:'10px', top:'50%', transform:'translateY(-50%)', color:'#94a3b8' }}>🔍</span>
                                <input className="pmt-search" placeholder="Search payments…" value={search} onChange={e => setSearch(e.target.value)} />
                            </div>
                            <button className="pmt-btn" style={{ background:'linear-gradient(135deg,#10b981,#059669)', color:'white', boxShadow:'0 4px 12px rgba(16,185,129,0.3)' }} onClick={recordPayment}>＋ Record Payment</button>
                        </div>
                    </div>

                    <div style={{ padding:'12px 24px', borderBottom:'1px solid #f1f5f9', display:'flex', gap:'8px', flexWrap:'wrap' }}>
                        {['All','Received','Pending','Overdue'].map(s => (
                            <button key={s} className={`filter-pill ${filterStatus === s ? 'active' : ''}`} onClick={() => setFilterStatus(s)}>{s}</button>
                        ))}
                    </div>

                    {loading ? (
                        <div style={{ padding:'60px', textAlign:'center', color:'#94a3b8' }}>⏳ Loading payments from server…</div>
                    ) : (
                    <div style={{ overflowX:'auto' }}>
                        <table style={{ width:'100%', borderCollapse:'collapse' }}>
                            <thead>
                                <tr style={{ background:'#f8fafc' }}>
                                    {['Payment ID','Invoice','Client','Date','Mode','Reference','Amount','Status','Actions'].map(h => (
                                        <th key={h} style={{ padding:'12px 18px', textAlign:'left', fontSize:'11px', fontWeight:'800', color:'#64748b', textTransform:'uppercase', letterSpacing:'0.8px', whiteSpace:'nowrap' }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.length === 0 && (
                                    <tr><td colSpan={9} style={{ padding:'50px', textAlign:'center', color:'#94a3b8' }}>
                                        <div style={{ fontSize:'40px', marginBottom:'10px' }}>💳</div>
                                        <div>No payments found</div>
                                        <button className="pmt-btn" style={{ marginTop:'12px', background:'#f0fdf4', color:'#16a34a' }} onClick={recordPayment}>+ Record First Payment</button>
                                    </td></tr>
                                )}
                                {filtered.map(p => {
                                    const sc = STATUS_COLORS[p.status] || { bg:'#f1f5f9', color:'#64748b' };
                                    return (
                                        <tr key={p.id} className="pmt-row" style={{ borderBottom:'1px solid #f1f5f9', background:'#fff' }}>
                                            <td style={{ padding:'14px 18px', fontWeight:'700', color:'#10b981', fontSize:'13px' }}>{p.id}</td>
                                            <td style={{ padding:'14px 18px', fontWeight:'600', color:'#3b82f6', fontSize:'13px' }}>{p.invoiceNo}</td>
                                            <td style={{ padding:'14px 18px' }}>
                                                <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                                                    <div style={{ width:'30px', height:'30px', borderRadius:'8px', background:`hsl(${(p.client||'').charCodeAt(0)*17 % 360},55%,55%)`, color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'700', fontSize:'12px', flexShrink:0 }}>{(p.client||'?').charAt(0)}</div>
                                                    <span style={{ fontWeight:'600', color:'#1e293b', fontSize:'13px' }}>{p.client}</span>
                                                </div>
                                            </td>
                                            <td style={{ padding:'14px 18px', fontSize:'13px', color:'#475569' }}>{p.date}</td>
                                            <td style={{ padding:'14px 18px', fontSize:'13px', color:'#475569' }}>{MODE_ICONS[p.mode] || '💳'} {p.mode}</td>
                                            <td style={{ padding:'14px 18px', fontSize:'12px', color:'#64748b', fontFamily:'monospace' }}>{p.ref}</td>
                                            <td style={{ padding:'14px 18px', fontSize:'14px', fontWeight:'800', color:'#0f172a' }}>₹{(p.amount||0).toLocaleString('en-IN')}</td>
                                            <td style={{ padding:'14px 18px' }}><span className="pmt-badge" style={{ background:sc.bg, color:sc.color }}>{p.status}</span></td>
                                            <td style={{ padding:'14px 18px' }}>
                                                <div style={{ display:'flex', gap:'6px' }}>
                                                    <button className="pmt-btn" style={{ padding:'5px 10px', background:'#eff6ff', color:'#2563eb', fontSize:'12px' }} onClick={() => alert(`Receipt\n${p.client} — ₹${p.amount?.toLocaleString('en-IN')}\nMode: ${p.mode}\nRef: ${p.ref}`)}>🧾 Receipt</button>
                                                    <button className="pmt-btn" style={{ padding:'5px 10px', background:'#fef2f2', color:'#dc2626', fontSize:'12px' }} onClick={() => deletePayment(p.id)}>🗑️</button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    )}

                    <div style={{ padding:'14px 24px', borderTop:'1px solid #f1f5f9', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                        <span style={{ fontSize:'13px', color:'#94a3b8' }}>Showing {filtered.length} of {payments.length} payments • Live from backend</span>
                        <span style={{ fontSize:'13px', fontWeight:'700', color:'#0f172a' }}>Total: ₹{filtered.reduce((a,p) => a+p.amount,0).toLocaleString('en-IN')}</span>
                    </div>
                </div>
            </div>
        </>
    );
}
